import * as qiniu from 'qiniu-js'
import { base64SrcToBlob } from './common'
import store from '../store'
import _ from 'lodash'

const tokenLoader = []

export const qiNiuDomain = process.env.VUE_APP_QINIU_DOMAIN

export function generateJobListPosterFileKey (companyId) {
  const fileKey = `image/company/${companyId}/job-list/poster/${new Date().valueOf()}`
  return generateTempFileKey(fileKey)
}

export function generateJobDetailPosterFileKey (jobShortId) {
  const fileKey = `image/job/detail/${jobShortId}/poster/${new Date().valueOf()}`
  return generateTempFileKey(fileKey)
}

export function generateCrmCampaignFileKey (campaignId) {
  if (!campaignId) {
    campaignId = '_vid'
  }
  const accountId = store.state.account.currentAccount.id
  const fileKey = `/crm/campaign/${campaignId}/${accountId}/${new Date().valueOf()}`
  return fileKey
}

export function generatePolicyFileKey (rootCompanyId, companyId) {
  const today = new Date()
  const date = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`
  const fileKey = `company/${rootCompanyId}/policy/${companyId}/${date}`
  return fileKey
}

export function getFilePath (fileKey) {
  if (!fileKey || fileKey.startsWith('http') || fileKey.startsWith('blob:http')) {
    return fileKey
  }
  if (fileKey.startsWith('/')) {
    fileKey = fileKey.substr(1)
  }
  return `${qiNiuDomain}${fileKey}`
}

export function generateTempFileKey (fileKey, tempLength) {
  let prefix = 'temp/'
  if (fileKey.startsWith('/')) {
    fileKey = fileKey.substr(1)
  }
  switch (tempLength) {
    case 1:
      prefix += '1d'
      break
    case 3:
      prefix += '3d'
      break
    case 5:
      prefix += '5d'
      break
    default:
      prefix += '1d'
      break
  }
  return `${prefix}/${fileKey}`
}

export async function getUploadToken (isPublic = true, mode) {
  const context = { is_public: isPublic, mode }
  let loader = _.find(tokenLoader, { context })
  if (!loader) {
    const promise = store.dispatch('common/getQiniuUploadToken', { is_public: isPublic, mode }).then(resp => resp.token)
    loader = { context, promise }
    tokenLoader.push(loader)
  }
  const token = await loader.promise
  return token
}

export function uploadFile (file, fileKey, isPublic = true, inProgress, mode) {
  return getUploadToken(isPublic, mode).then(token => new Promise((resolve, reject) => {
    const observable = qiniu.upload(file, fileKey, token, {}, { region: qiniu.region.z0 })
    observable.subscribe(
      (resp) => {
        // show progress
        if (inProgress) {
          inProgress(resp)
        }
      },
      (resp) => {
        // fail
        reject(resp)
      },
      (resp) => {
        // success
        resolve(resp)
      }
    )
  }))
}

export async function uploadBase64Src (fileKey, base64Src) {
  const blob = base64SrcToBlob(base64Src)
  return uploadFile(blob, fileKey)
}

export async function dataUrlToFile (dataUrl, fileName) {
  const res = await fetch(dataUrl)
  const blob = await res.blob()
  return new File([blob], fileName, { type: 'image/png' })
}

export async function resizeDataURL (base64Src, targetWidth, targetHeight) {
  return new Promise((resolve, reject) => {
    const img = document.createElement('img')
    img.onload = function () {
      const canvas = document.createElement('canvas')
      const ctx = canvas.getContext('2d')
      canvas.width = targetWidth
      canvas.height = targetHeight
      ctx.drawImage(this, 0, 0, targetWidth, targetHeight)
      const dataURI = canvas.toDataURL()
      resolve(dataURI)
    }
    img.src = base64Src
  })
}

export function getBindImageHeight (displayAspectRatio, imageWidth, imageHeight) {
  const ratios = displayAspectRatio.split(':')
  const width = parseInt(ratios[0])
  const height = parseInt(ratios[1])
  if (width && height) {
    return imageWidth * height / width
  }
  return imageHeight
}

export async function preCompressImage (file, width, height) {
  const options = {
    quality: 0.92,
    noCompressIfLarger: true,
    maxWidth: width,
    maxHeight: height
  }
  const data = await qiniu.compressImage(file, options)
  return data?.dist
}

// open question 专用生成上传qiniu fileKey
export function getFileUID (prefix) {
  // this method is copy from web/src/rpo/static/js/qiniu-plupload/moxie.js:502
  /** origin description:
   Generates an unique ID. The only way a user would be able to get the same ID is if the two persons
   at the same exact millisecond manage to get the same 5 random numbers between 0-65535; it also uses
   a counter so each ID is guaranteed to be unique for the given page. It is more probable for the earth
   to be hit with an asteroid.
   */
  const time = new Date().getTime().toString(32)
  const random = _.times(5, () => Math.floor(Math.random() * 65535).toString(32)).join('')
  const counter = _.uniqueId().toString(32)
  return (prefix || 'o_') + time + random + counter
}
